import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useFieldActions } from '../../../contexts/field-actions-context';
import { useFieldInitialData } from '../../../contexts/field-initial-data-context';
import { FIELD_TYPES } from '../../../constants';
export const useServiceDropdownOptions = props => {
  var _props$options;
  const {
    actions
  } = useFieldActions();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [isEmpty, setIsEmpty] = useState(((_props$options = props.options) == null ? void 0 : _props$options.length) === 0);
  const [hasInitialDataLoaded, setHasInitialDataLoaded] = useState(false);
  const shouldFetchData = useRef(true);
  const initialData = useFieldInitialData(FIELD_TYPES.SERVICES_DROPDOWN);
  const enrichOptions = useCallback(services => {
    return services.map(service => ({
      value: service.id ?? '',
      label: service.name ?? '',
      id: service.id ?? ''
    }));
  }, []);
  useEffect(() => {
    if (initialData != null && initialData.services) {
      const enrichedOptions = enrichOptions(initialData.services);
      setOptions(enrichedOptions);
      setIsEmpty(enrichedOptions.length === 0);
      setHasInitialDataLoaded(true);
    }
  }, [enrichOptions, initialData]);
  const serviceIds = useMemo(() => {
    var _props$options2;
    return ((_props$options2 = props.options) == null ? void 0 : _props$options2.map(option => option.id ?? '')) ?? [];
  }, [props.options]);
  const initData = useCallback(async () => {
    if (actions != null && actions.fetchServices && serviceIds.length > 0 && !props.isEditor) {
      setIsLoading(true);
      const relevantServices = await actions.fetchServices({
        serviceIds
      });
      const enrichedOptions = enrichOptions(relevantServices);
      setIsEmpty(enrichedOptions.length === 0);
      setOptions(enrichedOptions);
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceIds, props.isEditor]);
  const onFocus = useCallback(() => {
    if (props.onFocus) {
      props.onFocus();
    }
    if (shouldFetchData.current) {
      shouldFetchData.current = false;
      initData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initData, props.onFocus]);
  const onChange = useCallback(value => {
    if (props.onChange) {
      props.onChange(value);
    }
    shouldFetchData.current = true;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.onChange]);

  // Don't render the dropdown until initial data is loaded in live site
  const shouldRender = props.isEditor || hasInitialDataLoaded;
  return {
    isLoading,
    options,
    isEmpty,
    onFocus,
    onChange,
    shouldRender
  };
};
//# sourceMappingURL=use-service-dropdown-options.js.map